<template>
  <!-- index:main:bottom START -->
  <div
    class="inner"
    v-if="boxOpened.isOpen"
  >
    <!-- index:main:bottom:content START -->
    <div
      class="inner"
      v-if="box.hasAppCheckin === 0 && box.hasSmsCheckin === 0
      && box.hasCardCheckin === 0 && box.hasNfcCheckin === 0"
    >
      <div class="text" v-html="'0 - 0 - 0 - 0'"></div>
      <div class="text extra" v-html="'0 - 0 - 0 - 0'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 0 && box.hasSmsCheckin === 0
      && box.hasCardCheckin === 0 && box.hasNfcCheckin === 1"
    >
      <div class="text" v-html="'0 - 0 - 0 - 1'"></div>
      <div class="text extra" v-html="'0 - 0 - 0 - 1'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 0 && box.hasSmsCheckin === 0
      && box.hasCardCheckin === 1 && box.hasNfcCheckin === 0"
    >
      <div class="text" v-html="'0 - 0 - 1 - 0'"></div>
      <div class="text extra" v-html="'0 - 0 - 1 - 0'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 0 && box.hasSmsCheckin === 0
      && box.hasCardCheckin === 1 && box.hasNfcCheckin === 1"
    >
      <div class="text" v-html="'0 - 0 - 1 - 1'"></div>
      <div class="text extra" v-html="'0 - 0 - 1 - 1'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 0 && box.hasSmsCheckin === 1
      && box.hasCardCheckin === 0 && box.hasNfcCheckin === 0"
    >
      <div class="text" v-html="'0 - 1 - 0 - 0'"></div>
      <div class="text extra" v-html="'0 - 1 - 0 - 0'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 0 && box.hasSmsCheckin === 1
      && box.hasCardCheckin === 0 && box.hasNfcCheckin === 1"
    >
      <div class="text" v-html="'0 - 1 - 0 - 1'"></div>
      <div class="text extra" v-html="'0 - 1 - 0 - 1'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 0 && box.hasSmsCheckin === 1
      && box.hasCardCheckin === 1 && box.hasNfcCheckin === 0"
    >
      <div class="text" v-html="'0 - 1 - 1 - 0'"></div>
      <div class="text extra" v-html="'0 - 1 - 1 - 0'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 0 && box.hasSmsCheckin === 1
      && box.hasCardCheckin === 1 && box.hasNfcCheckin === 1"
    >
      <div class="text" v-html="'0 - 1 - 1 - 1'"></div>
      <div class="text extra" v-html="'0 - 1 - 1 - 1'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 1 && box.hasSmsCheckin === 0
      && box.hasCardCheckin === 0 && box.hasNfcCheckin === 0"
    >
      <div class="text" v-html="'1 - 0 - 0 - 0'"></div>
      <div class="text extra" v-html="'1 - 0 - 0 - 0'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 1 && box.hasSmsCheckin === 0
      && box.hasCardCheckin === 0 && box.hasNfcCheckin === 1"
    >
      <div class="text" v-html="'1 - 0 - 0 - 1'"></div>
      <div class="text extra" v-html="'1 - 0 - 0 - 1'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 1 && box.hasSmsCheckin === 0
      && box.hasCardCheckin === 1 && box.hasNfcCheckin === 0"
    >
      <div class="text" v-html="'1 - 0 - 1 - 0'"></div>
      <div class="text extra" v-html="'1 - 0 - 1 - 0'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 1 && box.hasSmsCheckin === 0
      && box.hasCardCheckin === 1 && box.hasNfcCheckin === 1"
    >
      <div class="text" v-html="'1 - 0 - 1 - 1'"></div>
      <div class="text extra" v-html="'1 - 0 - 1 - 1'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 1 && box.hasSmsCheckin === 1
      && box.hasCardCheckin === 0 && box.hasNfcCheckin === 0"
    >
      <div class="text" v-html="'1 - 1 - 0 - 0'"></div>
      <div class="text extra" v-html="'1 - 1 - 0 - 0'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 1 && box.hasSmsCheckin === 1
      && box.hasCardCheckin === 0 && box.hasNfcCheckin === 1"
    >
      <div class="text" v-html="'1 - 1 - 0 - 1'"></div>
      <div class="text extra" v-html="'1 - 1 - 0 - 1'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 1 && box.hasSmsCheckin === 1
      && box.hasCardCheckin === 1 && box.hasNfcCheckin === 0"
    >
      <div class="text" v-html="'1 - 1 - 1 - 0'"></div>
      <div class="text extra" v-html="'1 - 1 - 1 - 0'"></div>
    </div>

    <div
      class="inner"
      v-if="box.hasAppCheckin === 1 && box.hasSmsCheckin === 1
      && box.hasCardCheckin === 1 && box.hasNfcCheckin === 1"
    >
      <div class="text" v-html="'1 - 1 - 1 - 1'"></div>
      <div class="text extra" v-html="'1 - 1 - 1 - 1'"></div>
    </div>
    <!-- index:main:bottom:content END -->

    <!-- index:main:bottom:icons START -->
    <div class="icons">

      <!-- index:main:bottom:icons:app START -->
      <div
        class="icon"
        v-if="box.hasAppCheckin === 1"
      >
        <img :src="iconApp.src" />
      </div>
      <!-- index:main:bottom:icons:app END -->

      <!-- index:main:bottom:icons:sms START -->
      <div
        class="icon"
        v-if="box.hasSmsCheckin === 1"
      >
        <img :src="iconSms.src" />
      </div>
      <!-- index:main:bottom:icons:sms END -->

      <!-- index:main:bottom:icons:credit-card START -->
      <div
        class="icon"
        v-if="box.hasCardCheckin === 1"
      >
        <img :src="iconCC.src" />
      </div>
      <!-- index:main:bottom:icons:credit-card END -->

      <!-- index:main:bottom:icons:nfc START -->
      <div
        class="icon"
        v-if="box.hasNfcCheckin === 1"
      >
        <img :src="iconNfc.src" />
      </div>
      <!-- index:main:bottom:icons:nfc END -->

    </div>
    <!-- index:main:bottom:icons END -->

  </div>
  <!-- index:main:bottom END -->
</template>

<script>
import ICONS from '../../../utils/icons';

const {
  iPaymentApp,
  iPaymentSms,
  iPaymentCC,
  iPaymentNfc,
} = ICONS;

export default {
  name: 'box-status',
  props: {
    box: {
      type: Object,
    },
    boxOpened: {
      type: Object,
    },
  },
  data() {
    return {
      iconApp: {
        src: iPaymentApp.defaultUrl,
      },
      iconSms: {
        src: iPaymentSms.defaultUrl,
      },
      iconCC: {
        src: iPaymentCC.defaultUrl,
      },
      iconNfc: {
        src: iPaymentNfc.defaultUrl,
      },
    };
  },
};
</script>
